import { gql } from '@apollo/client';

export const ACTIVATE_KIT = gql`
  mutation ActivateKit($kitId: String!, $partner: String) {
    activateKit(kitId: $kitId, partner: $partner)
  }
`;
